import { module } from 'modujs';
import { AddToCart } from '../modules/CartEvents.js';
import Channels from '../base/channels';

export default class extends module {
  constructor(m) {
    super(m);
  }

  init() {
    this.DOM = {
      view: this.el,
    };
    this.DOM.form = this.DOM.view.querySelector('form[action$="/cart/add"]');
    this.events();
  }

  events() {
    Channels.addListener('addtocart::click', () => {
      this.send();
    });
  }

  send() {
    const data = new FormData(this.DOM.form);
    AddToCart(data, false);
  }
}
